import { twMerge } from '@/utils/tw-merge';

export interface FormLabelProps
  extends React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  > {
  required?: boolean;
}

export const FormLabel = ({
  children,
  className,
  required,
  ...props
}: FormLabelProps) => {
  return (
    <label
      {...props}
      className={twMerge(
        'style-input-label mb-1 block text-gray-800',
        className
      )}
    >
      {children}
      {required && (
        <>
          {` `}
          <sup>*</sup>
        </>
      )}
    </label>
  );
};
